import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    LinearProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { EntityActions } from "../../../Services/_actions/Entity/entity.actions.ts";
import { useSnackBar } from "../../FlowBuilder/Common/SnackBar/index.tsx";
import { useParams } from "react-router";
import LoadingButton from "../../Shared/Loading/index.tsx";
import { useRecoilValueLoadable } from 'recoil';
import { fetchEntityFormListSelector } from '../../../Services/_states/Entity/entitySelector.ts';
import { Checkbox, FormControlLabel } from '@mui/material';


const UploadFile = ({ onUploadSuccess }) => {
    const { showSnackBar } = useSnackBar();
    const actions = EntityActions();
    const { entityFormId } = useParams();
    const [selectedFile, setSelectedFile] = useState < any > (null);
    const [progress, setProgress] = useState(0);
    const [dataArr, setDataArr] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const entityFormList = useRecoilValueLoadable(fetchEntityFormListSelector("uploadFile"));
    const [formFields, setFormFields] = useState([]);
    const [checkedFields, setCheckedFields] = useState({});
    const ALLOWED_EXTENSIONS = ["xlsx"];
    const MAX_FILE_SIZE = 20 * 1024 * 1024; 


    useEffect(() => {
        if (entityFormList.state === 'hasValue') {
            const items = entityFormList.contents?.data || [];
            const matchedForm = items.find(item => item._id === entityFormId);
            if (matchedForm) {
                setFormFields(matchedForm.form_fields || []);
            }
        }
    }, [entityFormList, entityFormId]);

    const convertFileIntoJson = async (file) => {
    };

    // Validate email format
    const validateEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    // Validate phone number (basic numeric check)
    const validatePhone = (phone) => {
        return /^\d{10}$/.test(phone);
    };

 const handleFileChange = async (event) => {
  try {
    const file = event.target.files[0];
    if (!file) return;

    const fileName = file.name.toLowerCase();
    const ext = fileName.split(".").pop();

    // Extension check
    if (!ALLOWED_EXTENSIONS.includes(ext)) {
      showSnackBar(
        `Invalid file type. Allowed: ${ALLOWED_EXTENSIONS.join(", ")}`,
        "error"
      );
      event.target.value = ""; // Reset input
      return;
    }
    if (file.size > MAX_FILE_SIZE) {
      const sizeMB = (file.size / (1024 * 1024)).toFixed(2);
      showSnackBar(
        `File too large (${sizeMB} MB). Max allowed size is ${MAX_FILE_SIZE / (1024 * 1024)} MB.`,
        "error"
      );
      event.target.value = "";
      return;
    }
    setSelectedFile(file);
    setProgress(0);
  } catch (error) {
    showSnackBar("Error reading file", "error");
  }
};

    const onUploadProgress = (progressEvent) => {
        const { loaded, total } = progressEvent;
        const percent = Math.floor((loaded * 100) / total);
        setProgress(percent);
    };
    const handleSubmit = async () => {
        setIsLoading(true);
        try {
            const selectedFields = Object.keys(checkedFields).filter(fieldName => checkedFields[fieldName]);
            let formData = new FormData();
            formData.append('file', selectedFile);
            formData.append("form_fields", JSON.stringify(selectedFields));
            const res = await actions.uploadEntityData(formData, entityFormId, onUploadProgress);
            if (res?.status === 200) {
                showSnackBar("File submitted successfully", "success");
                 onUploadSuccess?.();
            } else {
                showSnackBar("File upload failed", "error");
            }
        } catch (error) {
            showSnackBar("Error uploading file", "error");
        } finally {
            setIsLoading(false);
        }
    };

    const handleCheckboxChange = (fieldName) => {
        setCheckedFields((prev) => ({
            ...prev,
            [fieldName]: !prev[fieldName],
        }));
    };

    return (
        <Card>
            <CardContent>
                <Typography variant="h6" className="pb-3">Upload Entity File</Typography>
                <input
                    type="file"
                    accept=".xlsx"
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    id="file-upload"
                />
                <label htmlFor="file-upload">
                    <Button variant="contained" component="span">
                        Upload File
                    </Button>
                </label>

                <Button variant="text" sx={{ ml: 2 }} onClick={() => actions.downloadEntitySampleFile(entityFormId)}>
                    Download Sample File
                </Button>
                <Typography
                    variant="body2"
                    sx={{ mt: 1, color: "text.secondary", fontSize: "13px" }}
                  >
                    Allowed: {ALLOWED_EXTENSIONS.join(", ").toUpperCase()} • Max Size{" "}
                    {MAX_FILE_SIZE / (1024 * 1024)} MB
                </Typography>


                {selectedFile && (
                    <Box display="flex" alignItems="center" mt={2}>
                        <Typography>{selectedFile?.name}</Typography>
                        <CloseIcon
                            onClick={() => setSelectedFile(null)}
                            sx={{ cursor: "pointer", ml: 2 }}
                        />
                    </Box>
                )}


                {selectedFile && progress > 0 && (
                    <LinearProgress variant="determinate" value={progress} sx={{ mt: 2 }} />
                )}

                {selectedFile && (
                    <>
                        {/* <Box>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Update Columns:
                            </Typography>
                            <Box
                                sx={{
                                    maxHeight: 300,
                                    overflowY: 'auto',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    gap: 2,
                                    marginTop: '8px',
                                    border: '1px solid #ccc',
                                    padding: '8px',
                                }}
                            >
                                {formFields.map((field, idx) => (
                                    <Box key={idx} sx={{ display: 'flex', alignItems: 'center', width: 'calc(50% - 8px)' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={checkedFields[field.name] || false}
                                                    onChange={() => handleCheckboxChange(field.name)}
                                                    size="small"
                                                />
                                            }
                                            label={field.label || field.name}
                                        />
                                    </Box>
                                ))}
                            </Box>
                        </Box> */}
                        <Box mt={2}>
                            <LoadingButton
                                buttonName="Submit"
                                onClickButton={handleSubmit}
                                isDisabled={isLoading}
                                isLoading={isLoading}
                            />
                        </Box>
                    </>
                )}

            </CardContent>
        </Card>
    );
};

export default UploadFile;